/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ButsInputs */

const de__field_buts = /** @type {(inputs: _Field_ButsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT`)
};

/**

* @param {_Field_ButsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_buts = /** @type {((inputs?: _Field_ButsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ButsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_buts(inputs)
});